import { render, staticRenderFns } from "./pentaLogo.vue?vue&type=template&id=3fbb0de3"
import script from "./pentaLogo.vue?vue&type=script&lang=js"
export * from "./pentaLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports